import { render, staticRenderFns } from "./AuthorBadge.vue?vue&type=template&id=20d1e9f2"
import script from "./AuthorBadge.vue?vue&type=script&lang=js"
export * from "./AuthorBadge.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/youtube/yt-live-chat-author-badge-renderer.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/css/youtube/yt-icon.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports